<template>
    <div class="memberList">
        <v-card class="cardWrap">
            <CardTitle title="予約状況照会（月指定）" />
                <v-form ref="form" lazy-validation>
                    <v-toolbar flat color="white" class="mt-1">
                        <v-select
                            class="mr-3 pt-4"
                            :items="years"
                            item-value="year"
                            item-text="year"
                            v-model="targetYear"
                            label="プレー年"
                        ></v-select>
                        <v-select
                            class="mr-3 pt-4"
                            :items="month"
                            item-value="id"
                            item-text="name"
                            v-model="targetMonth"
                            label="プレー月"
                        ></v-select>
                        <v-select
                            class="mr-3 pt-4"
                            :items="golfSelect"
                            item-value="golf_code"
                            item-text="golf_name"
                            v-model="golfCode"
                            label="ゴルフ場名"
                        ></v-select>
                        <v-btn
                            color="primary"
                            class="ml-5"
                            v-on:click="checkValidateSearch"
                            :disabled="btn[1].isActive"
                        >検索</v-btn>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-form>
                <v-data-table
                    :headers="headers"
                    :items="desserts"
                    hide-default-footer
                    class="elevation-1"
                    sort-by="play_date"
                    height="380"
                    fixed-header
                    disable-pagination
                >
                    <template v-slot:[`item.day1`]="{ item }"><a @click="reserveListByDayOpen(1)">{{ item.day1 }}</a></template>
                    <template v-slot:[`item.day2`]="{ item }"><a @click="reserveListByDayOpen(2)">{{ item.day2 }}</a></template>
                    <template v-slot:[`item.day3`]="{ item }"><a @click="reserveListByDayOpen(3)">{{ item.day3 }}</a></template>
                    <template v-slot:[`item.day4`]="{ item }"><a @click="reserveListByDayOpen(4)">{{ item.day4 }}</a></template>
                    <template v-slot:[`item.day5`]="{ item }"><a @click="reserveListByDayOpen(5)">{{ item.day5 }}</a></template>
                    <template v-slot:[`item.day6`]="{ item }"><a @click="reserveListByDayOpen(6)">{{ item.day6 }}</a></template>
                    <template v-slot:[`item.day7`]="{ item }"><a @click="reserveListByDayOpen(7)">{{ item.day7 }}</a></template>
                    <template v-slot:[`item.day8`]="{ item }"><a @click="reserveListByDayOpen(8)">{{ item.day8 }}</a></template>
                    <template v-slot:[`item.day9`]="{ item }"><a @click="reserveListByDayOpen(9)">{{ item.day9 }}</a></template>
                    <template v-slot:[`item.day10`]="{ item }"><a @click="reserveListByDayOpen(10)">{{ item.day10 }}</a></template>
                    <template v-slot:[`item.day11`]="{ item }"><a @click="reserveListByDayOpen(11)">{{ item.day11 }}</a></template>
                    <template v-slot:[`item.day12`]="{ item }"><a @click="reserveListByDayOpen(12)">{{ item.day12 }}</a></template>
                    <template v-slot:[`item.day13`]="{ item }"><a @click="reserveListByDayOpen(13)">{{ item.day13 }}</a></template>
                    <template v-slot:[`item.day14`]="{ item }"><a @click="reserveListByDayOpen(14)">{{ item.day14 }}</a></template>
                    <template v-slot:[`item.day15`]="{ item }"><a @click="reserveListByDayOpen(15)">{{ item.day15 }}</a></template>
                    <template v-slot:[`item.day16`]="{ item }"><a @click="reserveListByDayOpen(16)">{{ item.day16 }}</a></template>
                    <template v-slot:[`item.day17`]="{ item }"><a @click="reserveListByDayOpen(17)">{{ item.day17 }}</a></template>
                    <template v-slot:[`item.day18`]="{ item }"><a @click="reserveListByDayOpen(18)">{{ item.day18 }}</a></template>
                    <template v-slot:[`item.day19`]="{ item }"><a @click="reserveListByDayOpen(19)">{{ item.day19 }}</a></template>
                    <template v-slot:[`item.day20`]="{ item }"><a @click="reserveListByDayOpen(20)">{{ item.day20 }}</a></template>
                    <template v-slot:[`item.day21`]="{ item }"><a @click="reserveListByDayOpen(21)">{{ item.day21 }}</a></template>
                    <template v-slot:[`item.day22`]="{ item }"><a @click="reserveListByDayOpen(22)">{{ item.day22 }}</a></template>
                    <template v-slot:[`item.day23`]="{ item }"><a @click="reserveListByDayOpen(23)">{{ item.day23 }}</a></template>
                    <template v-slot:[`item.day24`]="{ item }"><a @click="reserveListByDayOpen(24)">{{ item.day24 }}</a></template>
                    <template v-slot:[`item.day25`]="{ item }"><a @click="reserveListByDayOpen(25)">{{ item.day25 }}</a></template>
                    <template v-slot:[`item.day26`]="{ item }"><a @click="reserveListByDayOpen(26)">{{ item.day26 }}</a></template>
                    <template v-slot:[`item.day27`]="{ item }"><a @click="reserveListByDayOpen(27)">{{ item.day27 }}</a></template>
                    <template v-slot:[`item.day28`]="{ item }"><a @click="reserveListByDayOpen(28)">{{ item.day28 }}</a></template>
                    <template v-slot:[`item.day29`]="{ item }"><a @click="reserveListByDayOpen(29)">{{ item.day29 }}</a></template>
                    <template v-slot:[`item.day30`]="{ item }"><a @click="reserveListByDayOpen(30)">{{ item.day30 }}</a></template>
                    <template v-slot:[`item.day31`]="{ item }"><a @click="reserveListByDayOpen(31)">{{ item.day31 }}</a></template>
                </v-data-table>
                <v-data-table
                    :headers="planHeaders"
                    :items="planDesserts"
                    hide-default-footer
                    class="elevation-1 minTable"
                    sort-by="play_date"
                    disable-pagination
                >
                <template v-slot:[`item.plan_name`]="{ item }"><span v-if="item.list_no === 1">{{ item.plan_name }}</span></template>
                <template v-slot:[`item.total_fee`]="{ item }"><span v-if="item.list_no === 1">{{ item.total_fee }}</span></template>
                <template v-slot:[`item.list_name`]="{ item }"><span class="word">{{ item.list_name.title }}<br>{{ item.list_name.sub}}</span></template>
                <template v-slot:[`item.day1`]="{ item }"><a @click="reserveListByDayOpen(1)">{{ item.day1.num }}<br>{{ item.day1.people }}</a></template>
                <template v-slot:[`item.day2`]="{ item }"><a @click="reserveListByDayOpen(2)">{{ item.day2.num }}<br>{{ item.day2.people }}</a></template>
                <template v-slot:[`item.day3`]="{ item }"><a @click="reserveListByDayOpen(3)">{{ item.day3.num }}<br>{{ item.day3.people }}</a></template>
                <template v-slot:[`item.day4`]="{ item }"><a @click="reserveListByDayOpen(4)">{{ item.day4.num }}<br>{{ item.day4.people }}</a></template>
                <template v-slot:[`item.day5`]="{ item }"><a @click="reserveListByDayOpen(5)">{{ item.day5.num }}<br>{{ item.day5.people }}</a></template>
                <template v-slot:[`item.day6`]="{ item }"><a @click="reserveListByDayOpen(6)">{{ item.day6.num }}<br>{{ item.day6.people }}</a></template>
                <template v-slot:[`item.day7`]="{ item }"><a @click="reserveListByDayOpen(7)">{{ item.day7.num }}<br>{{ item.day7.people }}</a></template>
                <template v-slot:[`item.day8`]="{ item }"><a @click="reserveListByDayOpen(8)">{{ item.day8.num }}<br>{{ item.day8.people }}</a></template>
                <template v-slot:[`item.day9`]="{ item }"><a @click="reserveListByDayOpen(9)">{{ item.day9.num }}<br>{{ item.day9.people }}</a></template>
                <template v-slot:[`item.day10`]="{ item }"><a @click="reserveListByDayOpen(10)">{{ item.day10.num }}<br>{{ item.day10.people }}</a></template>
                <template v-slot:[`item.day11`]="{ item }"><a @click="reserveListByDayOpen(11)">{{ item.day11.num }}<br>{{ item.day11.people }}</a></template>
                <template v-slot:[`item.day12`]="{ item }"><a @click="reserveListByDayOpen(12)">{{ item.day12.num }}<br>{{ item.day12.people }}</a></template>
                <template v-slot:[`item.day13`]="{ item }"><a @click="reserveListByDayOpen(13)">{{ item.day13.num }}<br>{{ item.day13.people }}</a></template>
                <template v-slot:[`item.day14`]="{ item }"><a @click="reserveListByDayOpen(14)">{{ item.day14.num }}<br>{{ item.day14.people }}</a></template>
                <template v-slot:[`item.day15`]="{ item }"><a @click="reserveListByDayOpen(15)">{{ item.day15.num }}<br>{{ item.day15.people }}</a></template>
                <template v-slot:[`item.day16`]="{ item }"><a @click="reserveListByDayOpen(16)">{{ item.day16.num }}<br>{{ item.day16.people }}</a></template>
                <template v-slot:[`item.day17`]="{ item }"><a @click="reserveListByDayOpen(17)">{{ item.day17.num }}<br>{{ item.day17.people }}</a></template>
                <template v-slot:[`item.day18`]="{ item }"><a @click="reserveListByDayOpen(18)">{{ item.day18.num }}<br>{{ item.day18.people }}</a></template>
                <template v-slot:[`item.day19`]="{ item }"><a @click="reserveListByDayOpen(19)">{{ item.day19.num }}<br>{{ item.day19.people }}</a></template>
                <template v-slot:[`item.day20`]="{ item }"><a @click="reserveListByDayOpen(20)">{{ item.day20.num }}<br>{{ item.day20.people }}</a></template>
                <template v-slot:[`item.day21`]="{ item }"><a @click="reserveListByDayOpen(21)">{{ item.day21.num }}<br>{{ item.day21.people }}</a></template>
                <template v-slot:[`item.day22`]="{ item }"><a @click="reserveListByDayOpen(22)">{{ item.day22.num }}<br>{{ item.day22.people }}</a></template>
                <template v-slot:[`item.day23`]="{ item }"><a @click="reserveListByDayOpen(23)">{{ item.day23.num }}<br>{{ item.day23.people }}</a></template>
                <template v-slot:[`item.day24`]="{ item }"><a @click="reserveListByDayOpen(24)">{{ item.day24.num }}<br>{{ item.day24.people }}</a></template>
                <template v-slot:[`item.day25`]="{ item }"><a @click="reserveListByDayOpen(25)">{{ item.day25.num }}<br>{{ item.day25.people }}</a></template>
                <template v-slot:[`item.day26`]="{ item }"><a @click="reserveListByDayOpen(26)">{{ item.day26.num }}<br>{{ item.day26.people }}</a></template>
                <template v-slot:[`item.day27`]="{ item }"><a @click="reserveListByDayOpen(27)">{{ item.day27.num }}<br>{{ item.day27.people }}</a></template>
                <template v-slot:[`item.day28`]="{ item }"><a @click="reserveListByDayOpen(28)">{{ item.day28.num }}<br>{{ item.day28.people }}</a></template>
                <template v-slot:[`item.day29`]="{ item }"><a @click="reserveListByDayOpen(29)">{{ item.day29.num }}<br>{{ item.day29.people }}</a></template>
                <template v-slot:[`item.day30`]="{ item }"><a @click="reserveListByDayOpen(30)">{{ item.day30.num }}<br>{{ item.day30.people }}</a></template>
                <template v-slot:[`item.day31`]="{ item }"><a @click="reserveListByDayOpen(31)">{{ item.day31.num }}<br>{{ item.day31.people }}</a></template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';

// mixin
import { utilityMixin } from '../../mixins/utility';
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';
import { codeListMixin } from '@/mixins/codeList';
import { judgeDayMixin } from '../../mixins/judgeDay';

// graphql
import {
    GET_LINK_YEARS,
    GET_RESERVE_TOTAL_LIST_BY_MONTH,
    GET_RESERVE_TOTAL_LIST_BY_GROUP
} from '@/constants/reserve';

export default {
    components: {
        CardTitle
    },
    mixins: [
        authorityMixin,
        utilityMixin,
        golfCourseMixin,
        codeListMixin,
        judgeDayMixin
    ],
    props: ['name'],
    data () {
        return {
            moveToPage: '',
            playDate: '',
            dialog: false,
            processing: false,
            // データテーブルに渡す値
            desserts: [],
            planDesserts: [],
            result: '',
            resultText: '',
            originalData: [],
            columnList: [],
            // データテーブルの見出し要素
            headers: [],
            // データテーブルの見出し要素
            planHeaders: [],
            // 生年月日の日付格納用
            date: null,
            // ゴルフ場選択の制御
            modeStatus: '',
            // データ格納用
            years: [],
            // 検索値
            targetYear: '',
            // 検索値
            targetMonth: '',
            // 検索値
            targetDate: '',
            // 検索値
            targetDays: 0,
            // 検索値
            golfCode: '',
            month: [
                { id: 0, name: '1月' },
                { id: 1, name: '2月' },
                { id: 2, name: '3月' },
                { id: 3, name: '4月' },
                { id: 4, name: '5月' },
                { id: 5, name: '6月' },
                { id: 6, name: '7月' },
                { id: 7, name: '8月' },
                { id: 8, name: '9月' },
                { id: 9, name: '10月' },
                { id: 10, name: '11月' },
                { id: 11, name: '12月' }
            ],
            dayOfWeek: [
                { id: 0, name: '日' },
                { id: 1, name: '月' },
                { id: 2, name: '火' },
                { id: 3, name: '水' },
                { id: 4, name: '木' },
                { id: 5, name: '金' },
                { id: 6, name: '土' }],
            // ログインしている者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true }
            ],
            vue_id: 'SCR0014',
            // ゴルフ場セレクトボックス
            golfSelect: [],
            detailInfo: {
                reserve_no: '',
                dialog: true
            },
            rules: {
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.stringtype'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            },
            // エラーメッセージ
            error: ''
        };
    },
    async created () {
        // loading画面を表示させる
        this.$store.commit('loading/setIsLoading', true);
        this.admin = await this.getLoginAdmin();
        this.golfSelect = await this.getGolfCourseList();
        this.golfCode = this.golfSelect[0].golf_code;
        if (this.$store.state.reserve.targetGolf) {
            this.golfCode = this.$store.state.reserve.targetGolf;
        }

        this.years = await this.getLinkYears();

        if (!this.$store.state.reserve.targetYear) {
            const today = new Date();
            this.targetYear = today.getFullYear().toString();
        } else {
            this.targetYear = this.$store.state.reserve.targetYear;
        }

        if (!this.$store.state.reserve.targetMonth) {
            const today = new Date();
            this.targetMonth = today.getMonth();
        } else {
            this.targetMonth = this.$store.state.reserve.targetMonth;
        }
        await this.makeHeaders();
        await this.makePlanHeaders();
        await this.getAuthorityList();
        await this.getCells();
        await this.getPlanCells();
        // loadingを戻す
        this.$store.commit('loading/setIsLoading', false);
    },
    beforeRouteLeave (to, from, next) {
        if (!this.updateFlag) {
            next();
        } else {
            this.moveToPage = to;
            this.moveDisplay = true;
        }
    },
    methods: {
        getLinkYears (pramCodeKey, defaultDisplay) {
            return this.$apollo.mutate({
                mutation: GET_LINK_YEARS,
                variables: { golfGroupCode: process.env.VUE_APP_GROUP_CODE }
            }).then(res => {
                return res.data.GetLinkYears.YearList;
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        /** --------------------------------------------
        * ヘッダーを作成
        * -------------------------------------------- */
        makeHeaders () {
            this.targetDays = new Date(this.targetYear, this.targetMonth + 1, 0).getDate();
            var dayList = [{ text: '', value: 'list_name', sortable: false, width: '400' }];
            this.columnList = [];
            this.columnList.push(this.targetDays);
            for (var i = 1; i <= this.targetDays; i++) {
                var date = new Date(this.targetYear, this.targetMonth, i);
                var day = this.dayOfWeek[date.getDay()]['name'];
                if (i < 10) {
                    dayList.push({ text: '0' + i + day, align: 'center', sortable: false, value: 'day' + i, class: 'dayWidth' + this.judgeDay(date), width: '35' });
                } else {
                    dayList.push({ text: i + day, align: 'center', sortable: false, value: 'day' + i, class: 'dayWidth' + this.judgeDay(date), width: '35' });
                }
                this.columnList.push('day' + i);
            }
            this.headers = dayList;
        },
        /** ----------------------------------------------
         * プランヘッダーを作成
         * ---------------------------------------------- */
        makePlanHeaders () {
            this.targetDays = new Date(this.targetYear, this.targetMonth + 1, 0).getDate();
            var dayList = [
                { text: 'プラン', value: 'plan_name', sortable: false, width: '200' },
                { text: '総額(税込)', value: 'total_fee', sortable: false, width: '100' },
                { text: '', value: 'list_name', sortable: false, width: '100' }
            ];
            this.columnList = [];
            this.columnList.push(this.targetDays);
            for (var i = 1; i <= this.targetDays; i++) {
                var date = new Date(this.targetYear, this.targetMonth, i);
                var day = this.dayOfWeek[date.getDay()]['name'];
                if (i < 10) {
                    dayList.push({ text: '0' + i + day, align: 'center', sortable: false, value: 'day' + i, class: 'dayWidth' + this.judgeDay(date), width: '35' });
                } else {
                    dayList.push({ text: i + day, align: 'center', sortable: false, value: 'day' + i, class: 'dayWidth' + this.judgeDay(date), width: '35' });
                }
                this.columnList.push('day' + i);
            }
            this.planHeaders = dayList;
        },
        /** --------------------------------------------
        * 枠場情報を取得
        * -------------------------------------------- */
        async getCells () {
            try {
                var y = this.targetYear;
                var m = this.targetMonth + 1;
                m = m < 10 ? '0' + m : m;
                this.targetFirstDate = y + '-' + m + '-01';
                await this.$apollo
                    .mutate({
                        mutation: GET_RESERVE_TOTAL_LIST_BY_MONTH,
                        variables: {
                            targetStart: this.targetFirstDate, targetDays: this.targetDays, golfGroupCode: process.env.VUE_APP_GROUP_CODE, golfCode: this.golfCode
                        }
                    })
                    .then(res => {
                        this.desserts = res.data.GetReserveTotalListByMonth.TotalList;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
        * プラン毎の枠場情報を取得
        * -------------------------------------------- */
        async getPlanCells () {
            try {
                var y = this.targetYear;
                var m = this.targetMonth + 1;
                m = m < 10 ? '0' + m : m;
                this.targetFirstDate = y + '-' + m + '-01';
                await this.$apollo
                    .mutate({
                        mutation: GET_RESERVE_TOTAL_LIST_BY_GROUP,
                        variables: {
                            targetStart: this.targetFirstDate,
                            targetDays: this.targetDays,
                            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
                            golfCode: this.golfCode
                        }
                    })
                    .then(res => {
                        const data = res.data.GetReserveTotalListByGroup.TotalList;
                        let prePlanName = '';
                        const totalList = data.map(el => {
                            el.total_fee = el.total_fee.toLocaleString();
                            // tableに同じプラン名を表示させたくないため
                            if (prePlanName === el.plan_name) {
                                el.plan_name = '';
                            } else {
                                prePlanName = el.plan_name;
                            }
                            // 二行で表示させるため
                            const title = el.list_name.split(/\n/);
                            el.list_name = {
                                title: title[0],
                                sub: title[1]
                            };
                            for (let i = 1; i <= this.targetDays; i++) {
                                if (el[`day${i}`]) {
                                    const data = el[`day${i}`].split(/\n/);
                                    el[`day${i}`] = {
                                        num: data[0],
                                        people: data[1]
                                    };
                                } else {
                                    el[`day${i}`] = {
                                        num: '',
                                        people: ''
                                    };
                                }
                            }
                            return el;
                        });
                        this.planDesserts = totalList;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        checkValidateSearch () {
            if (this.$refs.form.validate()) {
                // loading画面を表示させる
                this.$store.commit('loading/setIsLoading', true);
                this.clickSearch();
                // loadingを戻す
                this.$store.commit('loading/setIsLoading', false);
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        clickSearch: function () {
            this.makeHeaders();
            this.makePlanHeaders();
            this.getCells();
            this.getPlanCells();
        },
        /** ----------------------------------------------
         * プラン詳細を表示する
         * ---------------------------------------------- */
        openModal: function () {
            this.detailInfo.reserve_no = this.desserts.reserve_no;
            this.dialog = true;
            this.$refs.Modal.openModal();
        },
        /** ----------------------------------------------
         * 予約日付指定画面に遷移する
         * ---------------------------------------------- */
        reserveListByDayOpen: function (d) {
            var y = this.targetYear;
            var m = this.targetMonth + 1;
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            this.targetDate = y + '-' + m + '-' + d;
            this.$store.commit('reserve/setTargetDate', this.targetDate);
            this.$store.commit('reserve/setTargetGolf', this.golfCode);
            this.$store.commit('reserve/setTargetYear', this.targetYear);
            this.$store.commit('reserve/setTargetMonth', this.targetMonth);
            this.$router.push('/reserveListByDay');
        },
        /** ----------------------------------------------
         * 更新ダイアログを表示
         * ---------------------------------------------- */
        changeOverlayStart () {
            this.changeOverlay = true;
        },
        /** ----------------------------------------------
         * 更新フラグを立てる
         * ---------------------------------------------- */
        changeUpdateFlag: function () {
            this.updateFlag = true;
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep th.dayWidth0 {
        /* padding: 8px; */
        color: #DD0000 !important;
    }

    .v-data-table ::v-deep th.dayWidth1, .dayWidth2, .dayWidth3, .dayWidth4, .dayWidth5{
        /* padding: 8px; */
    }

    .v-data-table ::v-deep th.dayWidth6 {
        /* padding: 8px; */
        color: #0000CC !important;
    }

    .v-data-table ::v-deep .word{
        word-break: keep-all;
    }

    .minTable{
        min-height: 600px;
    }

    .v-data-table ::v-deep td {
        word-break: break-word;
        padding: 8px 5px;
    }
</style>
